import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/lib/utils";
export interface OrbitingCirclesProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
  reverse?: boolean;
  duration?: number;
  delay?: number;
  radius?: number;
  path?: boolean;
  iconSize?: number;
  speed?: number;
}
export function OrbitingCircles(t0) {
  const $ = _c(24);
  let children;
  let className;
  let props;
  let reverse;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      className,
      children,
      reverse,
      duration: t1,
      radius: t2,
      path: t3,
      iconSize: t4,
      speed: t5,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = reverse;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    reverse = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  const duration = t1 === undefined ? 20 : t1;
  const radius = t2 === undefined ? 160 : t2;
  const path = t3 === undefined ? true : t3;
  const iconSize = t4 === undefined ? 30 : t4;
  const speed = t5 === undefined ? 1 : t5;
  const calculatedDuration = duration / speed;
  let t6;
  if ($[10] !== path || $[11] !== radius) {
    t6 = path && <svg xmlns="http://www.w3.org/2000/svg" version="1.1" className="pointer-events-none absolute inset-0 size-full" aria-hidden="true"><circle className="stroke-primary stroke-1" cx="50%" cy="50%" r={radius} fill="none" /></svg>;
    $[10] = path;
    $[11] = radius;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== calculatedDuration || $[14] !== children || $[15] !== className || $[16] !== iconSize || $[17] !== props || $[18] !== radius || $[19] !== reverse) {
    t7 = React.Children.map(children, (child, index) => {
      const angle = 360 / React.Children.count(children) * index;
      return <div style={{
        "--duration": calculatedDuration,
        "--radius": radius,
        "--angle": angle,
        "--icon-size": `${iconSize}px`,
        top: "50%",
        left: "50%",
        marginTop: `calc(${iconSize}px / -2)`,
        marginLeft: `calc(${iconSize}px / -2)`
      } as React.CSSProperties} className={cn("animate-orbit absolute flex size-[var(--icon-size)] transform-gpu items-center justify-center rounded-full", {
        "[animation-direction:reverse]": reverse
      }, className)} {...props}>{child}</div>;
    });
    $[13] = calculatedDuration;
    $[14] = children;
    $[15] = className;
    $[16] = iconSize;
    $[17] = props;
    $[18] = radius;
    $[19] = reverse;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}